module.exports = __webpack_public_path__ + "images/react_router.a420f5a4.webp";